import { UserMenu } from './UserMenu';
import { useMaintenanceStore } from '../stores/maintenanceStore';
import { useAuthStore } from '../stores/authStore';
import { useSettingsStore } from '../stores/settingsStore';
import { MarketSelector } from '../components/common/MarketSelector';
import { HeaderWalletPill } from '../components/common/HeaderWalletPill';
import { PrivacyToggle } from '../components/common/PrivacyToggle';
import { useMarketSwitch } from '../utils/useMarketSwitch';

function MaintenanceBanner() {
  const enabled = useMaintenanceStore((s) => s.enabled);
  const role = useAuthStore((s) => s.user?.role);

  if (!enabled || role !== 'admin') return null;

  return (
    <div className="bg-warning/15 border-b border-warning/30 px-4 py-1.5 flex items-center justify-center gap-2">
      <span className="w-2 h-2 rounded-full bg-warning animate-pulse" />
      <span className="text-warning text-xs font-semibold uppercase tracking-wide">
        Maintenance Mode Active — Site is down for public users
      </span>
    </div>
  );
}

// Margin + futures have no active symbols in v1 but the page still
// loads with an explicit empty state. Keep them selectable but dim.
const EMPTY_MARKETS = ['margin', 'futures'] as const;

export function Header() {
  const selectedMarket = useSettingsStore((s) => s.selectedMarket);
  // setSelectedMarket is wrapped so a market change also resets any
  // per-page state that was scoped to the previous market (backtest
  // results, strategy builder wizard, selected paper portfolio).
  // See useMarketSwitch for the full list.
  const setSelectedMarket = useMarketSwitch();

  return (
    <>
      <MaintenanceBanner />
      <header className="flex items-center justify-between sm:grid sm:grid-cols-3 bg-sidebar-bg border-b border-sidebar-border h-12 px-4 flex-shrink-0 gap-3">
        {/* Left — logo + exchange */}
        <div className="flex items-center gap-2.5 min-w-0 sm:justify-self-start">
          <img src="/logo192.png" alt="Lynx Crypto" className="w-7 h-7 flex-shrink-0" />
          <span className="text-accent font-bold text-base tracking-tight hidden sm:inline">
            Lynx Crypto
          </span>
        </div>

        {/* Center — market selector. From sm:up the 3-col grid keeps this
            perfectly centered regardless of whether the right column has
            the portfolio switcher (spot) or just the user menu
            (margin/futures). */}
        <div className="flex justify-center">
          <MarketSelector
            value={selectedMarket}
            onChange={setSelectedMarket}
            emptyMarkets={[...EMPTY_MARKETS]}
          />
        </div>

        {/* Right — wallet pill + user menu */}
        <div className="flex items-center gap-2 sm:justify-self-end">
          <HeaderWalletPill />
          <PrivacyToggle />
          <UserMenu />
        </div>
      </header>
    </>
  );
}
